import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import {
  ExtractedMultipleShowcase,
  ExtractedSingleShowcaseResource,
  ShowcasesEntity,
  ShowcasesTypes
} from 'search/full-card/models/showcases';

import { selectIsMouseClick, ShowcasesState, } from 'search/full-card/reducers/showcases.reducer';
import { ScrollService } from 'search/full-card/services/scroll-service';
import { getIsFirstPage } from 'search/reducers/history.reducer';
import { EntityTypes } from '../../../../../../entity/models/entity';

@Component({
  selector: 'app-items-list',
  templateUrl: './items-list.component.html',
  styleUrls: ['./items-list.component.scss'],
})
export class ItemsListComponent implements OnChanges, OnDestroy {
  @Input() public items: (ExtractedSingleShowcaseResource | ExtractedMultipleShowcase | any)[];
  @Input() public type: string;
  @Input() public identifier: string;
  @Input() public isMultipleView: boolean;
  @Input() public entity: ShowcasesEntity;
  @Output() public setFocusOnBackButton: EventEmitter<void> = new EventEmitter();
  public subscriptions = new Subscription();
  public hasPreviousUrl: boolean;
  public isMouseClick: boolean;
  public showcasesTypes = ShowcasesTypes;
  public entityTypes = EntityTypes;

  constructor(
    public elementRef: ElementRef,
    private store: Store<ShowcasesState>,
    private scrollService: ScrollService,
  ) { }

  public ngOnChanges(changes: any) {
    const currentValue = changes.items.currentValue;
    const previousValue= changes.items.previousValue;

    this.subscriptions.add(this.store.select(selectIsMouseClick).subscribe((isMouseClick: boolean) => {
      this.isMouseClick = isMouseClick;
    }));
    const isShouldSetFocus = !changes.items.firstChange &&
                          currentValue.length &&
                          previousValue.length > 0 &&
                          previousValue.length < currentValue.length &&
                          !this.isMouseClick;

    this.subscriptions.add(this.store.select(getIsFirstPage).subscribe((isFirstPage: boolean) => {
      this.hasPreviousUrl = !isFirstPage;
    }));
    if ( this.type && previousValue
      && previousValue.length === 0
      && currentValue.length > 0
      && this.hasPreviousUrl
    ) {
      this.scrollService.scrollPage();
      this.setFocusOnBackButton.emit();
    }

    if (isShouldSetFocus) {
      const selector = `[data-focus-id=id${previousValue.length - 1}]`;
      setTimeout(() => (this.elementRef.nativeElement.querySelector(selector) as HTMLElement).focus());
    }
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
